import styled from 'styled-components';

const StyledAnchor = styled.span`
	display: inline-flex;
	align-items: center;
	cursor: help;
	border-bottom: 1px dotted rgba(255, 255, 255, 0.35);
`;

const StyledTooltip = styled.div`
	position: fixed;
	z-index: 10000;
	max-width: 280px;
	padding: 8px 10px;
	transform: translate(-50%, -100%);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 5px;
	background: rgba(15, 18, 24, 0.98);
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
	color: #ffffff;
	font-size: 11px;
	font-weight: 400;
	line-height: 1.4;
	text-align: left;
	white-space: normal;
	pointer-events: none;
`;

export { StyledAnchor, StyledTooltip };
